


























































import { Component, Vue, Prop } from "vue-property-decorator";
import { personnel } from "../../api/personnel/personnel";
import { StringHelpers } from "../../api/helpers/StringHelpers";
import { Company } from "../../api/personnel/company";
import { Specialty } from "../../api/personnel/specialty";
import { WOSpecialty } from "../../api/personnel/wospecialty";
@Component({
  name: "PersonnelList"
})
export default class PersonnelList extends Vue {
  public personnelList: any[] = [];
  public search: string = "";
  public companies: any[] = [];
  public specialties: any[] = [];
  public WOSpecialties: any[] = [];
  public companyList: any[] = [];
  public specialtyList: any[] = [];
  public woSpecialtyList: any[] = [];
  public loading: boolean = true;
  public fillTable() {
    let i = 0;
    for (const tempPerson of this.personnelList) {
      console.log(tempPerson);
      tempPerson.company = this.companyList.find(
        obj => obj.id === tempPerson.company_id
      ).name;
      tempPerson.specialty = this.specialtyList.find(
        obj => obj.id === tempPerson.specialty_id
      ).literal;
      tempPerson.WOSpecialty = this.woSpecialtyList.find(
        obj => obj.id === tempPerson.wo_specialty
      ).literal;
      if (!this.companies.some(e => e.text === tempPerson.company)) {
        this.companies.push({
          text: tempPerson.company,
          value: tempPerson.company
        });
      }
      if (!this.specialties.some(e => e.text === tempPerson.specialty)) {
        this.specialties.push({
          text: tempPerson.specialty,
          value: tempPerson.specialty
        });
      }
      if (!this.WOSpecialties.some(e => e.text === tempPerson.WOSpecialty)) {
        this.WOSpecialties.push({
          text: tempPerson.WOSpecialty,
          value: tempPerson.WOSpecialty
        });
      }
    }
    this.loading = false;
  }
  public personnelStatus({
    row,
    rowIndex
  }: {
    row: any;
    rowIndex: number;
  }): string {
    if (row.active === false) {
      return "warning-row";
    } else {
      if (this.personnelList[rowIndex].active === true) {
        return "success-row";
      } else {
        return "";
      }
    }
  }
  public handleClick(rowIndex: number, row: any) {
    this.$store.dispatch("updateCurrentObject", row);
    this.$store.dispatch("updateCurrentComponent", "AddPersonnel");
    this.$router.replace({ name: "load" });
  }
  public async created() {
    this.loading = true;
    await this.getSpecialtyList();
  }
  public filterHandler(value: string, row: any, column: any) {
    const property = column["property"];
    return row[property] === value;
  }
  public async getSpecialtyList() {
    Specialty.getAllSpecialties(
      this.$store.getters.getToken,
      this.$store.getters.getHost
    ).then(response => {
      response.json().then(resp => {
        this.specialtyList = JSON.parse(JSON.stringify(resp));
        this.getCompanyList();
      });
    });
  }
  public async getCompanyList() {
    Company.getAllCompanies(
      this.$store.getters.getToken,
      this.$store.getters.getHost
    ).then(response => {
      response.json().then(resp => {
        this.companyList = JSON.parse(JSON.stringify(resp));
        this.getWoSpecialtyList();
      });
    });
  }
  public async getWoSpecialtyList() {
    WOSpecialty.getAllWOSpecialties(
      this.$store.getters.getToken,
      this.$store.getters.getHost
    ).then(response => {
      response.json().then(resp => {
        this.woSpecialtyList = JSON.parse(JSON.stringify(resp));
        this.getPersonnelList();
      });
    });
  }
  public async getPersonnelList() {
    personnel
      .getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.personnelList = JSON.parse(JSON.stringify(resp));
          this.fillTable();
        });
      });
  }
}
// oldlace
